export default __webpack_public_path__ + "static/media/delete1024.5a977d46.png";